/*
  2026-10-12: the "+" quick-add on product cards. Prestige's quick-buy modal fetches /products/<handle> and pulls the
  <template id="quick-buy-content"> that only its stock main-product section prints. Every Calimia product template
  uses the custom perfect-pdp sections instead, so that template was never there and the "+" silently did nothing.

  This loads the hidden product.quick-buy template (stock main-product, buy blocks only) via ?view=quick-buy, so the
  pages customers actually see are untouched. If the template still can't be found, the "+" opens the product page.
*/
customElements.whenDefined('quick-buy-modal').then(() => {
  const QuickBuyModal = customElements.get('quick-buy-modal');
  const modalShow = Object.getPrototypeOf(QuickBuyModal.prototype).show;
  const cache = new Map();

  QuickBuyModal.prototype.show = async function () {
    const productUrl = `${window.Shopify.routes.root}products/${this.getAttribute('handle')}`;
    const root = document.documentElement;

    root.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    let html = cache.get(productUrl);

    try {
      if (!html) {
        // The card's handle can already carry ?variant=, so add the view parameter properly.
        const quickBuyUrl = new URL(productUrl, window.location.origin);
        quickBuyUrl.searchParams.set('view', 'quick-buy');
        html = await (await fetch(quickBuyUrl)).text();
        cache.set(productUrl, html);
      }
    } finally {
      root.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }

    const template = new DOMParser().parseFromString(html, 'text/html').getElementById('quick-buy-content');

    if (!template) {
      cache.delete(productUrl);
      window.location.href = productUrl;
      return;
    }

    const content = template.content;
    content.querySelectorAll('noscript').forEach((noScript) => noScript.remove());
    this.replaceChildren(content);
    window.Shopify?.PaymentButton?.init();

    return modalShow.call(this);
  };
});
